import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PuzzleProvider } from './context/PuzzleContext';
import { SylloProvider } from './context/SylloContext';
import { HotAndColdProvider } from './context/HotAndColdContext';
import { ByrdleProvider } from './context/ByrdleContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PuzzleProvider>
      <SylloProvider>
        <HotAndColdProvider>
          <ByrdleProvider>
            <App />
          </ByrdleProvider>
        </HotAndColdProvider>
      </SylloProvider>
    </PuzzleProvider>
  </React.StrictMode>
);
